import React from 'react';
import {Switch ,FormControl,FormGroup,FormControlLabel,Typography} from '@material-ui/core'
import {isEmpty, isUndefined} from 'lodash'
import { Tooltip } from '@mui/material';
import { injectIntl } from 'react-intl';

function CheckBoxInput(props) {
    const ChangeMstate=(e)=>{
        console.log(e.target.checked)
        props.onChangeMstate(e.target.checked,{Meta:props.Meta,MetaN:props.MetaN,Value:-1,Checked:e.target.checked,Type:"Column",isSwitch:true})
    }
    const GetLabel=()=>{
        switch(props.Meta){
            case "AktivitetID": return props.intl.formatMessage({ id: 'Label.Acitvity.Id' });
            case "Titel": return props.intl.formatMessage({ id: 'Table.Title' });
            case "Beskrivningsfältet": return props.intl.formatMessage({ id: 'Label.Description' });
            case "Anteckningar": return props.intl.formatMessage({ id: 'Annotations' });
            case "Taggar": return props.intl.formatMessage({ id: 'Tags.label' });
            case "Ärendenummer": return props.intl.formatMessage({ id: 'Label.Errand.Nr' });
            case "Kategori": return props.intl.formatMessage({ id: 'Table.Errand.Category' });
            case "Telefonnummer": return props.intl.formatMessage({ id: 'userProfile.Telephone' });
            case "Beskrivning": return props.intl.formatMessage({ id: 'Table.Description' });
            case "Förslag på åtgärd": return props.intl.formatMessage({ id: 'Label.Suggected.action' });
            case "Flöde": return props.intl.formatMessage({ id: 'Errand.Flow.Comment' });
            case "Medlemsbåt": return props.intl.formatMessage({ id: 'Label.member.Boats' });
            case "Båttillverkare": return props.intl.formatMessage({ id: 'Label.manufacturer.Boats' });
            case "Lat": return props.intl.formatMessage({ id: 'Label.latitude' });
            case "Long": return props.intl.formatMessage({ id: 'Label.longitude' });
            case "Skadeplats": return props.intl.formatMessage({ id: 'Errand.accident.Site' });
            case "Region": return props.intl.formatMessage({ id: 'Region' });
            case "Assistansbåtar": return props.intl.formatMessage({ id: 'Label.Assistance.Boats' });
            case "Larmorsak": return props.intl.formatMessage({ id: 'Table.Errand.Larm' });
            case "Skadeärendenr": return props.intl.formatMessage({ id: 'Label.Damage.Errand' });
            case "Uppskattat pris (ex moms)": return props.intl.formatMessage({ id: 'Label.Estimated.price' });
            case "Verkligt pris": return props.intl.formatMessage({ id: 'Label.Economy.price' });
            case "Faktura": return props.intl.formatMessage({ id: 'Errand.Economy.Invoice' });
            case "Artikelnr": return props.intl.formatMessage({ id: 'Table.Product.Nr1' });
            case "Benämning": return props.intl.formatMessage({ id: 'Table.Designation' });
            case "Visningsnamn": return props.intl.formatMessage({ id: 'Label.display.Name' });
            case "Leverantör": return props.intl.formatMessage({ id: 'Supplier' });
            case "E-Nummer": return props.intl.formatMessage({ id: 'Table.E.Number' });
            case "Typ": return props.intl.formatMessage({ id: 'Input.Type' });
            case "Utpris": return props.intl.formatMessage({ id: 'Table.Price.Utpris' });
            case "Inpris": return props.intl.formatMessage({ id: 'input.Inpris' });
            case "TB": return props.intl.formatMessage({ id: 'Table.Price.TB' });
            case "Antal": return props.intl.formatMessage({ id: 'Table.Quantity' });
            case "Använt": return props.intl.formatMessage({ id: 'Label.Used' });
            case "Rabatt": return props.intl.formatMessage({ id: 'Type.Discount' });
            case "Utpris Summa": return props.intl.formatMessage({ id: 'Label.Utprice.Sum' });
            case "AvtalId": return props.intl.formatMessage({ id: 'Label.ContractID' });
            case "AvtalTyp": return props.intl.formatMessage({ id: 'Contract.type' });
            case "Rubrik": return props.intl.formatMessage({ id: 'Title' });
            case "Med löpande": return props.intl.formatMessage({ id: 'Chips.With.onGoing' });
            case "Avtal TB": return props.intl.formatMessage({ id: 'Label.Contract.TB' });
            case "Avtal Inpris": return props.intl.formatMessage({ id: 'Label.Contract.Inpris' });
            case "Avtal Utpris": return props.intl.formatMessage({ id: 'Label.Contract.Utpris' });
            case "Avtal TG": return props.intl.formatMessage({ id: 'Label.Contract.TG' });
            case "EsigneringNr": return props.intl.formatMessage({ id: 'Label.Esigning.Nr' });
            case "Senaste händelse": return props.intl.formatMessage({ id: 'Table.Latest.event' });
            case "Mottagare": return props.intl.formatMessage({ id: 'Table.Receiver' });
            case "MöteId": return props.intl.formatMessage({ id: 'Label.Event.Id' });
            case "Syfte": return props.intl.formatMessage({ id: 'Table.Purpose' });
            case "Adress": return props.intl.formatMessage({ id: 'userProfile.Address' });
            case "Intern Kommentar": return props.intl.formatMessage({ id: 'Label.Comment.Intern' });
            case "FortnoxNr": return props.intl.formatMessage({ id: 'Label.Fortnox.Nr' });
            case "Total": return props.intl.formatMessage({ id: 'Total' });
            case "Kontaktperson ID": return props.intl.formatMessage({ id: 'Label.ContactId' });
            case "Kontaktperson namn": return props.intl.formatMessage({ id: 'Label.Contact.Name' });
            case "Kontaktperson e-post": return props.intl.formatMessage({ id: 'Label.Contact.Email' });
            case "Kontaktperson tele": return props.intl.formatMessage({ id: 'Label.Contact.Tele' });
            case "Kontaktperson roll": return props.intl.formatMessage({ id: 'Label.Contact.Role' });
            case "Kontaktperson personnr": return props.intl.formatMessage({ id: 'Label.Contact.PersonNr' });
            case "Firmatecknare": return props.intl.formatMessage({ id: 'Table.signatory' });
            case "Nyhetsbrev": return props.intl.formatMessage({ id: 'Table.newsletters' });
            case "Kundnr": return props.intl.formatMessage({ id: 'Label.Client.Nr' });
            case "KundId": return props.intl.formatMessage({ id: 'Label.Client.ID' });
            case "Kundnamn": return props.intl.formatMessage({ id: 'Customer.Name' });
            case "Kund orgnr": return props.intl.formatMessage({ id: 'Label.Client.Orgnr' });
            case "Divisionsnamn": return props.intl.formatMessage({ id: 'Division.Name' });
            case "Senaste aktivitet": return props.intl.formatMessage({ id: 'Label.latest.Activities' });
            case "Ansvarig Kontor": return props.intl.formatMessage({ id: 'Label.Office.Responsible' });
            case "Ansvarig E-post": return props.intl.formatMessage({ id: 'Label.Office.Responsible.Email' });
            case "Ansvarig Telefon": return props.intl.formatMessage({ id: 'Label.Office.Responsible.Tele' });
            case "Kund epost": return props.intl.formatMessage({ id: 'Label.Customer.Email' });
            case "Telefon": return props.intl.formatMessage({ id: 'TelephonNumber' });
            case "Extra Telefon": return props.intl.formatMessage({ id: 'Label.Extra.Tele' });
            case "Hemsida": return props.intl.formatMessage({ id: 'Input.WebSite' });
            case "Extra adress": return props.intl.formatMessage({ id: 'Label.Extra.Address' });
            case "Leveransnamn": return props.intl.formatMessage({ id: 'Label.Supplier.Namn' });
            case "LeveransTele": return props.intl.formatMessage({ id: 'Label.Supplier.Tele' });
            case "Leveransadress": return props.intl.formatMessage({ id: 'Input.Delivary.Address' });
            case "Fakturanamn": return props.intl.formatMessage({ id: 'Label.Invoice.Name' });
            case "FakturaTele": return props.intl.formatMessage({ id: 'Label.Invoice.Tele' });
            case "FakturaEpost": return props.intl.formatMessage({ id: 'Label.Invoice.Email1' });
            case "Fakturaadress": return props.intl.formatMessage({ id: 'Input.Invoice.Address' });
            case "Extra Fakturaadress": return props.intl.formatMessage({ id: 'Label.Extra.Invoice.Address' });
            case "Antal fria fält": return props.intl.formatMessage({ id: 'Label.total.Free.Inputs' });
            case "Offertnr": return props.intl.formatMessage({ id: 'Label.OfferNR' });
            case "Offertnamn": return props.intl.formatMessage({ id: 'Input.OfferName' });
            case "Status": return props.intl.formatMessage({ id: 'Table.Status' });
            case "OrderNr": return props.intl.formatMessage({ id: 'Input.OrderNr' });
            case "Order affär från": return props.intl.formatMessage({ id: 'Label.Order.BusinessFrom' });
            case "Typ av affär": return props.intl.formatMessage({ id: 'input.TypeOfbusiness' });
            case "Order antal": return props.intl.formatMessage({ id: 'Label.Order.Total' });
            case "Order antal ny": return props.intl.formatMessage({ id: 'Label.Order.Total.new' });
            case "Order antal förlängnig": return props.intl.formatMessage({ id: 'Label.Order.Total.extension' });
            case "Porteringar (Till operatör)": return props.intl.formatMessage({ id: 'Label.Porting.Operator' });
            case "Mötesbokare": return props.intl.formatMessage({ id: 'user.Role.Meetingbooker' });
            case "Växel": return props.intl.formatMessage({ id: 'Type.Product.Contract.option5' });
            case "Provision": return props.intl.formatMessage({ id: 'commission' });
            case "Utpris totalt": return props.intl.formatMessage({ id: 'Label.Utprice.Total' });
            case "Order värde Inpris": return props.intl.formatMessage({ id: 'Label.Inprice.Total' });
            case "Order TBavdrag": return props.intl.formatMessage({ id: 'Label.Order.TB.deduction' });
            case "Order värde TG": return props.intl.formatMessage({ id: 'Label.Order.Value.TG' });
            case "Ordervärde intäkt": return props.intl.formatMessage({ id: 'Label.Order.Value.Income' });
            case "Ordervärde kostnad": return props.intl.formatMessage({ id: 'Label.Order.Value.Cost' });
            case "Utpris intäkt": return props.intl.formatMessage({ id: 'Label.Utprice.Income' });
            case "Utpris kostnad": return props.intl.formatMessage({ id: 'Label.Utprice.Cost' });
            case "Utpris ordervärde": return props.intl.formatMessage({ id: 'Label.Utprice.OrderValue' });
            case "Utpris ordervärde intäkt": return props.intl.formatMessage({ id: 'Label.Utprice.OrderValue.Income' });
            case "Utpris ordervärde kostnad": return props.intl.formatMessage({ id: 'Label.Utprice.OrderValue.Cost' });
            case "Utpris löpande": return props.intl.formatMessage({ id: 'Header.Calc.Utpris.OnGoing' });
            case "Utpris löpande intäkt": return props.intl.formatMessage({ id: 'Label.Utprice.onGoing.Income' });
            case "Utpris löpande kostnad": return props.intl.formatMessage({ id: 'Label.Utprice.onGoing.Cost' });
            case "Total omsättning (Löpande)per månad": return props.intl.formatMessage({ id: 'Label.Total.per.month1' });
            case "Total omsättning (Utpris)per månad": return props.intl.formatMessage({ id: 'Label.Total.per.month2' });
            case "ProjektNr": return props.intl.formatMessage({ id: 'Label.ProjectNr' });
            case "ProjektName": return props.intl.formatMessage({ id: 'Label.ProjectName' });
            case "Anteckning": return props.intl.formatMessage({ id: 'Annotation' });
            case "Kalkylerade timmar": return props.intl.formatMessage({ id: 'Label.Calculated.hours' });
            case "Medarbetare": return props.intl.formatMessage({ id: 'Table.Coworker' });
            case "Arbetade timmar": return props.intl.formatMessage({ id: 'Label.Working.hours' });
            case "Fakturerbara timmar": return props.intl.formatMessage({ id: 'Label.Ivoicable.hours' });
            case "Tid Kommentar": return props.intl.formatMessage({ id: 'Label.Time.Commets' });
            case "ProspektId": return props.intl.formatMessage({ id: 'Label.Prospect.Id' });
            case "Sannolikhet": return props.intl.formatMessage({ id: 'Probability' });
            case "Prospekt TB": return props.intl.formatMessage({ id: 'Label.Prospect.TB' });
            case "Prospekt Inpris": return props.intl.formatMessage({ id: 'Label.Prospect.Inpris' });
            case "Prospekt Utpris": return props.intl.formatMessage({ id: 'Label.Prospect.Utpris' });
            case "Prospekt TG": return props.intl.formatMessage({ id: 'Label.Prospect.TG' });
            case "Abonnemang": return props.intl.formatMessage({ id: 'Invoicing' });
            case "Avtalslängd": return props.intl.formatMessage({ id: 'input.ContractLength' });
            case "Fakturaintervall": return props.intl.formatMessage({ id: 'input.invoice.Options' });
            case "Betalningsvillkor": return props.intl.formatMessage({ id: 'input.Payment.methode' });
            case "Abonnemang löpande": return props.intl.formatMessage({ id: 'Label.Report.Invoincing.onGoing' });
            case "Abonnemang status": return props.intl.formatMessage({ id: 'Label.Report.Invoincing.status' });
            case "Order Kontor": return props.intl.formatMessage({ id: 'Office' });
            case "Order beskrivning": return props.intl.formatMessage({ id: 'appKontoModule.Description' });
            case "Artikel Fria fält": return props.intl.formatMessage({ id: 'Label.Free.Input' });





            default: return props.Meta
        }
    }
    return (
        <>
             <FormControl component="fieldset" fullWidth style={{margin:"3px auto"}}>
                <FormGroup aria-label="position" row>
                <FormControlLabel
                value={true}                
                control={
                    <Switch color="primary" 
                    disabled={props.disabled} 
                    checked={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))?false:true}
                    onChange={ChangeMstate}
                    size="small"
                    />
                }
                label={ 
                    !isUndefined(props.tooltip)?
                    <Tooltip title={`${GetLabel()} (${props.tooltip})`}>
                        <Typography variant="subtitle1" style={{fontSize:14}}>{GetLabel()}</Typography>    
                    </Tooltip>
                    :
                    <Typography variant="subtitle1" style={{fontSize:14}}>{GetLabel()}</Typography>
                }
                labelPlacement={"end"}
                />
                </FormGroup>
             </FormControl>
        </>
    );
}

export default injectIntl(CheckBoxInput);